export enum ActionType {
  RequestLatestSearchResults = 'feature/latestSearch/REQUEST_LATEST_SEARCH_RESULTS',
  HandleResponseLatestSearchResults = 'features/latestSearch/HANDLE_RESPONSE_LASTEST_SEARCH_RESULTS',
  HandleResponseErrorLatestSearchResults = 'feature/latestSearch/HANDLE_RESPONSE_ERROR_LATEST_SEARCH_RESULTS',
}
